import { SlamaRequestTypes } from "../../utils/constants";
import ViewPayment from "../common/ViewPayment";
import { capitalizeWords } from "../../utils/util";

const UserSpecificCard = ({ userDetails, setRequestStep, translationMap }) => {
  let fullName = capitalizeWords(`${userDetails?.PatientFirstName || ''} ${userDetails?.patientLastName || ''}`).trim();
  return (
    <>

                <div className="cover_inner_box">
                    <div className="content_box2 content_box2_bg">
                        <h6>
                            <p>
                                {translationMap?.currentlyViewingReportsFor}
                            </p>
                        </h6>
                        <div className="badge_box">
                            <p className="custom_badge_link">
                      <span className="icon_box">
                        <i className="material-symbols-outlined">person</i>
                      </span>
                                {fullName}
                            </p>
                        </div>
                        <div className="Info_Note_Box">
                    <span className="icon_box">
                      <i className="material-symbols-outlined">info</i>
                    </span>
                            <div className="content_box">
                                <p>
                                    {translationMap?.notCorrectDependentText}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="content_box2 content_box2_bg">
                        <h6>
                            <p>{translationMap?.needAMedicalReport}</p>
                        </h6>
                        <div className="btn_box">
                            <button className="blue_btn_link" onClick={() => setRequestStep(0)}>
                                {translationMap?.medicalReportRequest}
                            </button>
                        </div>
                    </div>

                    <ViewPayment translationMap={translationMap}
        to={`/payment-history/${SlamaRequestTypes.medicalReportRequest}`} />

                </div>

        </>);

};

export default UserSpecificCard;